import { entityBaseBodyRender, TableColumn } from '@app/components/common/table';

import { booleanEditableBodyRender } from '../common/table/body-renders/bool-editable';

export const useColumns = ({
  onChange,
}: {
  onChange(id: string, value: boolean, refetch: () => void): void;
}): TableColumn[] => {
  return [
    {
      name: 'id',
      label: '#',
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: 'name',
      label: 'Модель',
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: 'equipment_model_stand',
      label: 'Тип',
      options: {
        filter: {
          name: 'equipment_model_stand_id',
          sourceName: 'equipment_model_stand',
          type: 'multi-select'
        },
        sort: true,
        customBodyRender: entityBaseBodyRender(true),
      },
    },
    {
      name: 'brand',
      label: 'Бренд',
      options: {
        filter: {
          name: 'brand_id',
          sourceName: 'stand_brand',
          type: 'multi-select'
        },
        sort: true,
        customBodyRender: entityBaseBodyRender(true),
      },
    },
    {
      name: 'is_deleted',
      label: 'Отображать в визите',
      options: {
        filter: false,
        sort: false,
        customBodyRender: booleanEditableBodyRender({
          isInverted: true,
          onChange,
        }),
      },
    },
  ];
};
